module.exports = __webpack_public_path__ + "img/productWX_6.2de239b2.png";